import { render, staticRenderFns } from "./HomeHeader.vue?vue&type=template&id=781d0397&scoped=true&"
import script from "./HomeHeader.vue?vue&type=script&lang=js&"
export * from "./HomeHeader.vue?vue&type=script&lang=js&"
import style0 from "./HomeHeader.vue?vue&type=style&index=0&id=781d0397&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781d0397",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSharedLang: require('/app/components/ui/shared/lang.vue').default,UiSharedDialogsDialogMFullPage: require('/app/components/ui/shared/dialogs/DialogMFullPage.vue').default})
